"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../../util");
const components_1 = require("../../../components");
const TabBar = function (prop) {
    const { c } = prop;
    const { tabsLeft, tabsRight, currentTabLeft, currentTabRight, addTab, closeTab, error, setCurrentTab, } = c;
    const refLeft = (0, react_1.createRef)();
    const refRight = (0, react_1.createRef)();
    const [dLeft, setDLeft] = (0, react_1.useState)(false);
    const [dRight, setDRight] = (0, react_1.useState)(false);
    const fc = (event) => {
        const cur = refLeft.current;
        if (!cur) {
            return;
        }
        if (event.deltaY > 0) {
            cur.scrollTo({ left: cur.scrollLeft + 50 });
        }
        else {
            cur.scrollTo({ left: cur.scrollLeft - 50 });
        }
    };
    const fca = (event) => {
        const cur = refRight.current;
        if (!cur) {
            return;
        }
        if (event.deltaY > 0) {
            cur.scrollTo({ left: cur.scrollLeft + 50 });
        }
        else {
            cur.scrollTo({ left: cur.scrollLeft - 50 });
        }
    };
    (0, react_1.useEffect)(() => {
        const rl = refLeft.current;
        const rr = refRight.current;
        rl?.addEventListener('wheel', fc);
        rr?.addEventListener('wheel', fca);
        return () => {
            rl?.removeEventListener('wheel', fc);
            rr?.removeEventListener('wheel', fca);
        };
    });
    async function onDrop(e, target, position) {
        const id = e.dataTransfer.getData('id');
        const type = e.dataTransfer.getData('type');
        if (target === type) {
            return;
        }
        let tab;
        if (type === 'left') {
            tab = tabsLeft.find((el) => el.key === id);
        }
        else if (type === 'right') {
            tab = tabsRight.find((el) => el.key === id);
        }
        if (!tab) {
            error('NoTab');
            return;
        }
        closeTab(id, type);
        addTab(tab, target, position);
    }
    return (react_1.default.createElement("div", { className: (0, util_1.cnx)('tab-bar', [tabsRight.length === 0, 'tab-bar--single']) },
        react_1.default.createElement("div", { className: (0, util_1.cnx)('glx-tab-bar-l'), ref: refLeft, onDragOver: (e) => {
                e.preventDefault();
                setDLeft(true);
            }, onDragLeave: (e) => {
                e.preventDefault();
                setDLeft(false);
            }, onMouseLeave: () => {
                setDLeft(false);
            }, onMouseEnter: () => {
                setDRight(false);
            }, onDrop: async (e) => onDrop(e, 'left') },
            tabsLeft.map(({ titel, key, icon }, index) => (react_1.default.createElement(components_1.Tooltip, { key: key, text: titel, position: "right" },
                react_1.default.createElement("div", { draggable: true, onDragStart: (e) => {
                        e.dataTransfer.setData('id', key);
                        e.dataTransfer.setData('type', 'left');
                    }, onDrop: async (e) => onDrop(e, 'left', index), className: (0, util_1.cnx)('tab-bar--item', [index === currentTabLeft, ' tab-bar--item-selected'], [
                        dLeft && index === tabsLeft.length - 1,
                        'glx-drop-nonce--active-border',
                    ]) },
                    react_1.default.createElement("span", { className: "tab-bar--button", role: "button", onClick: () => {
                            setCurrentTab(index, 'left');
                        } },
                        icon ? (0, react_icons_1.getIcon)(icon)({}) : null,
                        (0, util_1.trimmer)(titel)),
                    react_1.default.createElement("button", { type: "button", className: "tab-bar--button-close", onClick: () => {
                            closeTab(key, 'left');
                        } },
                        react_1.default.createElement(react_icons_1.IOClose, { size: react_icons_1.ISize.SL })))))),
            tabsLeft.length === 0 ? (react_1.default.createElement("div", { className: (0, util_1.cnx)('glx-electron-no-drag', 'glx-no-select', [
                    dLeft,
                    'glx-drop-nonce--active',
                ]) }, "|")) : null),
        react_1.default.createElement("div", { className: "glx-tab-bar-r", ref: refRight, onDragOver: (e) => {
                e.preventDefault();
                setDRight(true);
            }, onDragLeave: (e) => {
                e.preventDefault();
                setDRight(false);
            }, onMouseLeave: () => {
                setDRight(false);
            }, onMouseEnter: () => {
                setDLeft(false);
            }, onDrop: async (e) => onDrop(e, 'right') },
            tabsRight.map(({ titel, key, icon }, index) => (react_1.default.createElement("div", { key: key, draggable: true, onDragStart: (e) => {
                    e.dataTransfer.setData('id', key);
                    e.dataTransfer.setData('type', 'right');
                }, onDrop: async (e) => onDrop(e, 'left', index), className: (0, util_1.cnx)('tab-bar--item', [index === currentTabRight, ' tab-bar--item-selected'], [
                    dRight && index === tabsRight.length - 1,
                    'glx-drop-nonce--active-border',
                ]) },
                react_1.default.createElement("span", { className: "tab-bar--button", role: "button", onClick: () => {
                        setCurrentTab(index, 'right');
                    } },
                    icon ? (0, react_icons_1.getIcon)(icon)({}) : null,
                    (0, util_1.trimmer)(titel)),
                react_1.default.createElement("button", { type: "button", className: "tab-bar--button-close", onClick: () => {
                        closeTab(key, 'right');
                    } },
                    react_1.default.createElement(react_icons_1.IOClose, { size: react_icons_1.ISize.SL }))))),
            tabsRight.length === 0 ? (react_1.default.createElement("div", { className: (0, util_1.cnx)('glx-electron-no-drag', 'glx-no-select', [
                    dRight,
                    'glx-drop-nonce--active',
                ]) }, "|")) : null)));
};
exports.default = TabBar;
